import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Table from '@vcomponents/AppTable';
import { createColumnHelper } from '@tanstack/react-table';
import { Badge } from 'reactstrap';
import './style.scss';

const STATUS_COLORS = {
  starting: 'primary',
  running: 'success',
  stopping: 'warning',
  stopped: 'info',
  fatal: 'danger',
};

const JobSupervisorModal = () => {
  const { payload } = useSelector((state) => state.modal);

  const SupervisorTableData = useMemo(() => {
    const history = payload?.workers ?? [];

    return {
      data: history.map((item, index) => ({
        ...item,
        id: index + 1,
      })),
      from: 1,
      to: history.length,
      total: history.length,
      pageIndex: 0,
      pageSize: history.length,
      pageCount: 1,
      loading: false,
    };
  }, [payload]);

  const columnHelper = createColumnHelper();

  const JobSupervisorColumns = () => [
    columnHelper.accessor('name', {
      header: 'Worker Name',
      cell: ({ getValue }) => (
        <div className='text-secondary font-weight-bold name-column'>
          {getValue()}
        </div>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      cell: ({ row }) => {
        const status = row.original.status?.toLowerCase();
        const color = STATUS_COLORS[status] || 'secondary';
        return (
          <div className='text-center status-column'>
            <Badge color={color} className='text-capitalize'>
              {row.original.status}
            </Badge>
          </div>
        );
      },
    }),
    columnHelper.accessor('meaning', {
      header: 'Meaning',
      cell: ({ getValue }) => <div className='name-column'>{getValue()}</div>,
    }),

    columnHelper.accessor('info', {
      header: 'Info',
      cell: ({ getValue }) => <div className='name-column'>{getValue()}</div>,
    }),
  ];

  return (
    <div className='job-supervisor-table'>
      <Table
        key='job-supervisor-table'
        state={{
          columns: JobSupervisorColumns(),
          data: SupervisorTableData,
        }}
        pagination={false}
        actions={{}}
      />
    </div>
  );
};

export default JobSupervisorModal;
